import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { EntitlementDeniedState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../lib/auth";

// Fail-closed route guard for platform-staff catalog administration. Only a user
// whose global platformRole is exactly "platform_admin" may reach the admin
// surface; everyone else sees the shared denied state. The server enforces the
// same check on every mutation — this guard is only a UX shortcut.
export function PlatformAdminGuard({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) return <LoadingState label="Checking your access…" />;
  if (user?.platformRole !== "platform_admin") {
    return <EntitlementDeniedState product="Platform administration" onUpgrade={() => navigate("/studio")} />;
  }
  return <>{children}</>;
}
